import moment from 'moment';

export const getSessionPlansTotalAmount = (sessionPlans) => {
  let plansTotalAmount = 0;
  sessionPlans && sessionPlans.forEach((sessionPlan) => {
    plansTotalAmount += sessionPlan.totalAmount;
  });

  return plansTotalAmount;
};

export const getPlanFromPlansByDate = (plans, date) => {
  if (!(plans && plans.length)) {
    return undefined;
  }

  let firstDay = false;

  const plan = plans.find((p) => {
    const { startDate, stayNights } = p;
    const planStartDate = moment(startDate);
    const diff = date.diff(planStartDate, 'days');
    if (diff === 0) {
      firstDay = true;
    }

    return -1 < diff && diff < stayNights;
  });

  return plan && {
    ...plan.plan,
    checkin: plan.checkin,
    firstDay,
  };
};

export const getPlanFromSessionPlansByDate = (sessionPlans, date) => {
  if (!(sessionPlans && sessionPlans.length)) {
    return undefined;
  }

  let firstDay = false;

  const plan = sessionPlans.find((sessionPlan) => {
    const { date: sessionPlanDate, stayNights } = sessionPlan;
    const planStartDate = moment(sessionPlanDate);
    const diff = date.diff(planStartDate, 'days');
    if (diff === 0) {
      firstDay = true;
    }

    return -1 < diff && diff < stayNights;
  });

  return plan && {
    ...plan,
    checkin: plan.checkin,
    firstDay,
  };
};

export const getStayNightsFromPlan = (plan, plans) => {
  if (!(plans && plans.length)) {
    return 0;
  }

  const item = plans.find((p) => {
    return p.plan.id === plan.id;
  });

  return item && item.stayNights;
};

export const getDaysToNextPlan = (date, plans) => {
  if (!(plans && plans.length)) {
    return undefined;
  }

  const plansDates = plans.map((p) => moment((p.startDate)));
  const plansDatesDiff = plansDates.map((startDate) => startDate.diff(date, 'days')).filter((d) => d > 0);

  const minDiff = plansDatesDiff.reduce((pre, current) => {
    return current < pre ? current : pre;
  }, plansDatesDiff[0]);

  return minDiff;
};
